import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoSmoke = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M7,13v4" }),
			/* @__PURE__ */ _jsx("path", { d: "M21,13v4" }),
			/* @__PURE__ */ _jsx("path", { d: "M16,4c0,3 2,3 2,6" }),
			/* @__PURE__ */ _jsx("path", { d: "M9,10l4,10" }),
			/* @__PURE__ */ _jsx("path", { d: "M15,17h3v-4h-5" }),
			/* @__PURE__ */ _jsx("path", { d: "M19,3c0,3 2,3 2,6" }),
			/* @__PURE__ */ _jsx("path", { d: "M11.8,17h-8.8v-4h7.2" })
		]
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0,0h24v24h-24Z"
	})]
});
export default SvgNoSmoke;
